<mat-dialog-content style="min-width: 280px; padding-bottom: 12px">
  <h3 style="color: #000000; font-weight: 600; font-size: 11px; margin-bottom: 0">{{data.title}}</h3>
  <p style="font-size: 14px" *ngIf="data.value.length>0">{{data.value}}</p>
  <p *ngIf="data.htmlValue" [innerHTML]="trustHtml(data.htmlValue, sanitizer)"></p>
</mat-dialog-content>
<mat-dialog-actions align="end" style="margin: 0 24px 12px 24px">
  <button mat-stroked-button mat-dialog-close style="margin: 0">{{'OK' | translate}}</button>
</mat-dialog-actions>
